import React from "react";
import "./HeroSection.css";

const HeroSection = () => {
  return (
    <div className="hero-section">
      <div className="hero-content">
        <h1>
          Revitalising Resilient <br />
          <span>Businesses, Catalysing</span>
          <br />
          <span>Exponential Growth</span>
        </h1>
        <p>
          India-focused special situations investment platform, designed to
          create value through significant equity-oriented construct.
        </p>
        <div className="scroll-indicator">
          <span>&#x2193;</span>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
